export enum LifeCycleStatus {
	Other = 'Other',
	ReceiveSigning = 'ReceiveSigning',
	CustomerVerification = 'CustomerVerification',
	DocumentsUpload = 'DocumentsUpload',
	InternalCheck = 'InternalCheck',
	SendToBo = 'SendToBo',
	Disbursed = 'Disbursed',
	Canceled = 'Canceled',
	TimedOut = 'TimedOut',
	Denied = 'Denied',
	Duplicated = 'Duplicated',
	ApplicationReceived = 'ApplicationReceived',
	CreditDecisionRunning = 'CreditDecisionRunning',
	CreditDecisionInvestigation = 'CreditDecisionInvestigation',
	CreditDecisionError = 'CreditDecisionError',
	SendIncomeVerification = 'SendIncomeVerification',
	ReceiveIncomeVerification = 'ReceiveIncomeVerification',
	PrintPromissoryNote = 'PrintPromissoryNote',
	Invalid = 'Invalid',
	ManualSendPromissoryNote = 'ManualSendPromissoryNote',
	CollectRefinData = 'CollectRefinData',
	CreditDecisionAwaitConsents = 'CreditDecisionAwaitConsents',
	FinalCreditApproval = 'FinalCreditApproval',
	MultiStepUpdateLoanData = 'MultiStepUpdateLoanData',
	MultiStepUpdatePersonalData = 'MultiStepUpdatePersonalData',
	CreditDecisionWaitingForFeedback = 'CreditDecisionWaitingForFeedback',
	CreditDecisionFeedbackReceived = 'CreditDecisionFeedbackReceived',
	CustomerVerificationFailed = 'CustomerVerificationFailed',
	AccountNumberVerificationFailed = 'AccountNumberVerificationFailed',
	IdentificationReceivedId = 'IdentificationReceivedId',
	AwaitAccept = 'AwaitAccept',
	ExternalRegisterCheck = 'ExternalRegisterCheck',
	ExternalRegisterCheckSend = 'ExternalRegisterCheckSend',
}

export enum IgnoreLifeCycleStatus {
	Denied = 'Denied',
	Disbursed = 'Disbursed',
	TimedOut = 'TimedOut',
	Duplicated = 'Duplicated',
	Canceled = 'Canceled',
}

export enum Status {
	NotCreated = 'NotCreated',
	Created = 'Created',
	Signed = 'Signed',
	Canceled = 'Canceled',
	SendByPost = 'SendByPost',
	Declined = 'Declined',
}

export enum Decision {
	Approved = 'Approved',
	Investigation = 'Investigation',
	Rejected = 'Rejected',
	Invalid = 'Invalid',
	Error = 'Error',
}

export enum SigningUrlType {
	ApplicantSigning = 'ApplicantSigning',
	CoapplicantSigning = 'CoapplicantSigning',
	OnlineIdentification = 'OnlineIdentification',
	ApplicantPsd2 = 'ApplicantPsd2',
	CoapplicantPsd2 = 'CoapplicantPsd2',
	PpiContract = 'PpiContract',
}
